import type { BaseScenarioParams } from './types'

type TemplateMountScenarioFn <T extends BaseScenarioParams> = (params: T) => Promise<void>

declare global {
  interface Window {
    BusyRooms: BusyRoomsGlobal
  }

  interface BusyRoomsGlobal {
    /** Generic scenario mounting function */
    mountScenario?: TemplateMountScenarioFn<any>

    onLoaded?: () => void
  }
}

/**
 * The Federated entrypoint for the IBE.
 * It will attach the `mountScenario` function to `window.BusyRooms` when in browser context.
 * @param mountScenario Function which mounts the scenario to the DOM
 */
export function attachMountScenarioToWindow <T extends BaseScenarioParams> (
  mountScenario: TemplateMountScenarioFn<T>
) {
  // Browser-only
  if (typeof window === 'undefined') return

  // Create BusyRooms namespace if it doesn't exist
  if (typeof window.BusyRooms === 'undefined') {
    window.BusyRooms = {}
  }

  // Also export `mountScenario` function
  window.BusyRooms.mountScenario = mountScenario

  // Check callback
  if (typeof window.BusyRooms.onLoaded === 'function') {
    window.BusyRooms.onLoaded()
  }
}
